import * as React from "react"
import { Route, Switch } from "react-router-dom"
import Loadable from "@bappweb/loadable"
import Header from "@smpu-web/globalmodules/header"
import Footer from "@smpu-web/globalmodules/footer"
import Landing from "./landing"
import Block from "@bappweb/block"
import { useAppDispatch } from "../config/hook"

const Main = () => {
  const dispatch = useAppDispatch()

  const routes = React.useMemo(
    () => ({
      Landing,
      Details: () => <Loadable loader={() => import("./details")} />,
      Result: () => <Loadable loader={() => import("./result")} />,
      // eslint-disable-next-line react/no-multi-comp
      NotFound: () => <Loadable loader={() => import("./not-found-404")} />
    }),
    []
  )

  return (
    <>
      <Block type="main" className="bapp-main">        
      <Header/>
        <Switch>
          <Route exact path="/" component={routes.Landing} />
          <Route path ="/details/*" component={routes.Details} />
          <Route path= "/result/*" component={routes.Result} />
          <Route component={routes.NotFound} />
        </Switch>        
      <Footer />
      </Block>
      
    </>
  )
}

export default Main
